import React, { Component } from 'react'
import { Query } from 'react-apollo'
import { GENERAL_CONTENT_VARIABLES, GENERAL_CONTENT_QUERY } from '../../query/generalcontent'
import Loading from '../../components/loading/loading'
import HtmlParse from 'html-react-parser';
import { Helmet } from 'react-helmet';

class GeneralContentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="static-page-container">
        <Query variables={GENERAL_CONTENT_VARIABLES} query={GENERAL_CONTENT_QUERY}>
          {({ data, loading, error }) => {
            if (loading || !data) {
              return <Loading />
            } else if (error) console.error(error)
            else {
              return (
                <div className="content-container">
                  <Helmet>
                    <title>{data.SuperContent.Title} - Radyo D</title>
                  </Helmet>
                  <h2>{data.SuperContent.Title}</h2>
                  {HtmlParse(data.SuperContent.Text)}
                </div>
              )
            }
          }}
        </Query>
      </div>
    )
  }
}

export default GeneralContentPage
